import React, { useEffect, useState } from 'react';
import { ButtonSizes, SKButton } from '../../../components/SwapKiwi/Button';
import { useSelector } from 'react-redux';
import { selectRecipient } from '../../../ducks/app/selectors';
import { getIsAllApproved } from '../../../ducks/nft/selectors';

interface ICreateSwapSwapButton {
  handleCreateSwap: () => void;
  createSwapLoading: boolean;
}

export const CreateSwapButton: React.FC<ICreateSwapSwapButton> = ({ handleCreateSwap, createSwapLoading }) => {
  const recipient = useSelector(selectRecipient);
  const [noRecipient, setNoRecipient] = useState(recipient ? recipient.length < 0 : true);
  const areAllNFTsApproved = useSelector(getIsAllApproved);

  useEffect(() => {
    setNoRecipient(recipient ? recipient.length < 0 : true);
  }, [recipient]);

  return (
    <SKButton
      size={ButtonSizes.XL}
      color="primary"
      disabled={!areAllNFTsApproved || noRecipient || createSwapLoading}
      onClick={handleCreateSwap}
    >
      Create the swap
    </SKButton>
  );
};
